<template>
    <div class="textfield">
        <div ref="textfield" class="textfield-wrapper" :class="{truncate: truncate && !isFullView}">
            <template v-for="(paragraph, index) in paragraphs" :key="index">
                {{ paragraph }}
                <br v-if="index < paragraphs.length - 1" />
            </template>
        </div>
        <VJoyButton v-if="isCTAVisible" class="more-cta joy-mt-2" size="xsmall" variant="ghost" @click="isFullView = !isFullView">
            {{ $t(`profile.vetting.drawer.qualification.field.${isFullView ? 'less' : 'more'}`) }}
        </VJoyButton>
    </div>
</template>

<script setup lang="ts">
    import {ref, toRef} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import {useTextField} from '~/composables/admin-section-tabs/useTextField';
    import type {TextFieldProps} from '~/types/TextFieldProps';

    const props = withDefaults(defineProps<TextFieldProps>(), {
        replaceBy: '-',
        truncateLine: 5,
    });

    const textfield = ref(null);
    const textFieldComposable = useTextField(props, textfield);
    // const {paragraphs, isCTAVisible, isFullView} = textFieldComposable;
    const paragraphs = toRef(textFieldComposable, 'paragraphs');
    const isCTAVisible = toRef(textFieldComposable, 'isCTAVisible');
    const isFullView = toRef(textFieldComposable, 'isFullView');
</script>

<style scoped lang="scss">
    .truncate {
        height: calc(1lh * v-bind(truncateLine));
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .textfield {
        border-radius: var(--joy-core-radius-4);
        background-color: var(--joy-color-neutral-20);
        display: inline-block;
    }
</style>
